import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';
import { ASSETS } from '../../utils/config';

// Pulse animation
const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

// Container for the component
const HoverBetaContainer = styled.div`
  display: inline-block;
  position: relative;
  cursor: pointer;
  width: 90px; /* Ensure container matches the image width */
  height: 40px; /* Ensure container matches the image height */
  margin-right: 10px;
`;

// Styled for the images
const BetaImage = styled.img`
  width: 100%;
  height: 100%;
  position: absolute; /* Ensure both images overlap */
  animation: ${pulse} 1.5s infinite;
  transition: opacity 0.5s, transform 0.5s;
`;

export const EnterBetaButton = ({ onClickBeta, onlyInvite = false, button = ASSETS.InviteBtn }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <HoverBetaContainer
      onMouseEnter={() => !onlyInvite && setHovered(true)}
      onMouseLeave={() => !onlyInvite && setHovered(false)}
      onClick={onClickBeta}
    >
      {/* Image for "Want In" */}
      <BetaImage
        src={button}
        style={{
          opacity: hovered ? 0 : 1,
          transform: hovered ? 'translateY(-10px)' : 'translateY(0)',
        }}
      />

      {/* Image for "Enter Beta" */}
      <BetaImage
        src={ASSETS.EnterBeta}
        style={{
          opacity: hovered ? 1 : 0,
          transform: hovered ? 'translateY(0)' : 'translateY(10px)',
        }}
      />
    </HoverBetaContainer>
  );
};
